module.exports = __webpack_public_path__ + "img/wf-finishing-position-29.733a2cf8.svg";